// Imagen destacada de cada servicio (se muestra en la página de detalle del servicio).
const U = "?q=80&w=1400&auto=format";

export const SERVICE_IMAGES = {
  "planificacion-estrategica": "/assets/service-planificacion.webp",
  "monitoreo-evaluacion-aprendizaje": "/assets/service-mel.webp",
  "investigacion-estudios": "/assets/service-investigacion.webp",
  "analisis-datos-evidencia": "/assets/service-analisis-datos.webp",
  "diseno-proyectos-resultados": "/assets/service-diseno-proyectos.webp",
  "facilitacion-sistematizacion": "/assets/service-facilitacion.webp",
};

// "contain" = la imagen es un diagrama y no debe recortarse (se muestra completa sobre fondo blanco).
export const SERVICE_IMAGE_FIT = {
  "monitoreo-evaluacion-aprendizaje": "contain",
};
